import type { JSX } from 'react';

import { Helmet } from 'react-helmet-async';

import { useMetaPetitionItemList } from './hooks/useMetaPetitionItemList';

export function MetaPetitionItemList(): JSX.Element | null {
	const {
		data: { displayed, schemaJson },
	} = useMetaPetitionItemList();

	if (!displayed) {
		return null;
	}

	return (
		<Helmet>
			<script type="application/ld+json">{schemaJson}</script>
		</Helmet>
	);
}
